import "./app.scss";
import { RootState } from "../store";
import { getSocialChannels, getNotifications } from "@/store/app/app.actions";
import { BrowserRouter, useLocation } from "react-router-dom";
import AppRoutes from "../routes/routes";
import { LinearLoader } from "../components";
import { connect, ConnectedProps } from "react-redux";
import { Suspense, useEffect, useState } from "react";
import { useSocket } from "../hooks/socket";
import { SocketContext } from "../context";
import { getSingleCurrentUser } from "@/store/user/user.action";
import { fetchHosts } from "@/store/media/media.action";
import { ToastProvider, Toast } from "../components";
import {
  getBunchListData,
  getListDenmarkHosts,
} from "@/store/constants/constants.action";

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
};

function App({
  getSocialChannels,
  rootLoading,
  getSingleCurrentUser,
  fetchHosts,
  isModalOpen,
  isSideNavClose,
  singleCurrentUser,
  getBunchListData,
  getListDenmarkHosts,
  getNotifications,
  hosts,
}: Props) {
  const { socketWrapper } = useSocket();
  const [isOnline] = useState(true);

  useEffect(() => {
    getSingleCurrentUser().catch((err) => {
      console.error("Error fetching current user:", err);
      const accountsUrl = process.env.NX_APP_ACCOUNTS;
      if (accountsUrl) {
        const currentHref = encodeURIComponent(window.location.href);
        window.location.href = `${accountsUrl}?redirect=${currentHref}`;
      } else {
        console.error("Cannot redirect to login.");
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (singleCurrentUser && hosts.length === 0) {
      fetchHosts({});
      getSocialChannels();
      getBunchListData({
        keys: [
          "business",
          "team",
          "all_business_team",
          "language",
          "category",
          "source",
        ],
      });
      getListDenmarkHosts({});
      getNotifications({ foreign_keys: ["meta", "state"] });
    }
  }, [singleCurrentUser?.id]);

  useEffect(() => {
    if (isModalOpen || !isSideNavClose) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isModalOpen, isSideNavClose]);

  return (
    <BrowserRouter>
      <ScrollToTop />
      {/* <NetworkErrorBanner /> */}
      <Suspense fallback={<LinearLoader />}>
        <ToastProvider>
          <SocketContext.Provider value={{ socketWrapper }}>
            <AppRoutes />
          </SocketContext.Provider>
        </ToastProvider>
        <Toast />
      </Suspense>
    </BrowserRouter>
  );
}

const mapState = (state: RootState) => ({
  rootLoading: state.app.rootLoading,
  isModalOpen: state.app.isModalOpen,
  isSideNavClose: state.app.isSideNavClose,
  singleCurrentUser: state.users.singleCurrentUser,
  hosts: state.media.hostList.list,
});

const mapDispatch = {
  getSocialChannels,
  getNotifications,
  getSingleCurrentUser,
  fetchHosts,
  getBunchListData,
  getListDenmarkHosts,
};

const connector = connect(mapState, mapDispatch);
type Props = ConnectedProps<typeof connector>;

export default connector(App);
